export const AddReleaseView = () => {
  return <div>AddReleaseView</div>;
};
